Bingo.CheckRemovedAgents = {};

Bingo.CheckRemovedAgents.init = function (form, modal) {
    let project = null;
    const clients = [];
    let result = true;
    form.serializeArray().forEach((element) => {
        if (element.name === 'project') {
            project = element.value;
        }
        if (element.name === 'soldByAgencies[]') {
            clients.push(element.value);
        }
    });
    jQuery.ajax({
        url: '/api/v1/sold-by-remove-agent',
        data: {
            id: project,
            clients,
        },
        success(response) {
            if (response.data.showBookingRemoveModal) {
                modal.modal();
                result = false;
            }
        },
        async: false,
    });
    return result;
};
